import { css } from "@emotion/css";
import React from "react";
import { Button, Icon } from "semantic-ui-react";
import "../../styles/ui.scss";
import "../../styles/bc-theme.scss";
import { getIsWhiteLabeled } from "../../helpers/PermissionHelper";

interface BPProps {
  className?: string;
  labelPosition?: any;
  iconName?: string;
  fluid?: boolean;
  type?: any;
  handleOnClick?: any;
  children?: any;
  disabled?: any;
  loading?: any;
  brokerColor?: any;
  inverted?: boolean;
}
const BCButton = ({ ...props }: BPProps) => (
  <div className="bp-button-container">
    <Button 
      className={(getIsWhiteLabeled()) && props.className === "profile-button" ? 
      css`
      background-color: ${props.brokerColor ? props.brokerColor : "black"} !important;
      color: #ffffff !important;
      font-family: 'Roboto', Helvetica, sans-serif !important;
      width: 50%
      ` :
      (getIsWhiteLabeled()) ? css`
        background-color: ${props.brokerColor ? props.brokerColor : "black"} !important;
        color: #ffffff !important;
        font-family: 'Roboto', Helvetica, sans-serif !important;
        ` : 
        `bp-button ${props.className && props.className}`}
      onClick={props.handleOnClick}
      icon={props.iconName ? true : false}
      labelPosition={props.labelPosition && props.labelPosition}
      type={props.type}
      fluid={props.fluid}
      disabled={props.disabled}
      loading={props.loading}
      inverted={props.inverted}
    >
      {props.children}
      {props.labelPosition && <Icon className={props.iconName} />}
    </Button>
  </div>
);

export default BCButton;